import styled, { css } from "styled-components";

interface HeaderStyledProps {
  showHeader?: boolean;
  isRedHeader?: boolean;
  isBauCartFlowInMobile?: boolean;
  mobileReductionEnabled?: boolean;
}

export const HeaderStyled = styled.header<HeaderStyledProps>`
  ${({ theme, showHeader, isRedHeader, isBauCartFlowInMobile, mobileReductionEnabled }) => {
    const { media, colors } = theme;
    const useMobileReductionPadding = mobileReductionEnabled && isBauCartFlowInMobile;

    return css`
      opacity: ${showHeader ? 1 : 0} !important;
      align-items: center;
      background: ${isRedHeader ? colors.primary.red : colors.primary.white};
      display: flex;
      padding: ${isRedHeader ? "10px 0" : useMobileReductionPadding ? "16px 0 24px" : "20px 0"};
      position: relative;
      width: 100%;

      ${media.tablet.up} {
        padding: ${isRedHeader ? "10px 0" : "25px 0"};
      }

      .icon--frontier-logo {
        color: ${isRedHeader ? colors.primary.white : colors.primary.red};
      }

      .progress-bar {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
      }

      .btn-skip {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-left: auto;
        background: none;
        border: none;
        font-size: 0.875rem;
        font-weight: 700;
        text-decoration: underline;
        text-transform: uppercase;
        cursor: pointer;

        .icon--fill-chevron-right {
          width: 20px;
          height: 20px;
        }
      }

      .checkout {
        &__back {
          width: 32px;
          height: 32px;
          margin-right: 10px;
          transform: rotate(180deg);
          cursor: pointer;
          &:hover {
            color: ${colors.primary.red};
          }
        }

        &__container {
          display: flex;
          align-items: center;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          gap: 8px;
          font-weight: 700;
          font-size: 19px;
          color: ${colors.primary.red};
        }

        &__frontier-icon {
          height: 20px;
          width: 20px;
        }
      }

      .container {
        align-items: center;
        display: flex;
        justify-content: space-between;
        position: relative;

        .eero-logo {
          padding-left: 32px;
        }

        .quiz__exit {
          color: ${colors.primary.darkBlue};
          display: flex;
          align-items: center;
          position: absolute;
          top: 0;
          right: 0;
          font-weight: 500;
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
          outline: inherit;

          .icon {
            height: 20px;
            margin-left: 10px;

            path {
              fill: ${colors.primary.darkBlue};
            }
          }
        }

        ${isBauCartFlowInMobile &&
        css`
          .frontier-logo-link {
            margin: 0 auto;
          }
        `}
      }
    `;
  }};
`;
